import { FC } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/auth-context";
import Loading from "../../Loading";

const PrivateRoute: FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const { isAuthenticated, authReady } = useAuth();

  // Establishing the session is now a request to the API rather than a synchronous cookie
  // read, so this is a real (if short) wait on every load — show something for it.
  if (!authReady) {
    return <Loading />;
  }

  if (isAuthenticated) {
    return <>{children}</>;
  }

  return <Navigate to="/login" state={{ from: location.pathname }} replace />;
};

export default PrivateRoute;
